import template from './changespercoder.html';
import controller from './changespercoder.controller';
import './changespercoder.styl';

let changespercoderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default changespercoderComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/changespercoder/changespercoder.component.js